import { FaBrain, FaClock, FaCloud, FaCode, FaGem, FaGlobe, FaHeadset, FaNetworkWired, FaRocket } from 'react-icons/fa';
import { images } from '../constants'; 

const careerIntro = {
    sub: "Leading the Future of AI",
    heading: "Your Gateway to AI and IT Solutions",
    description: "Welcome to AIByte, innovation meets expertise. We deliver cutting-edge AI and IT services tailored to meet the unique needs of businesses worldwide. From seamless integrations to transformative digital solutions, we empower your organization to thrive in the digital era.",
    points: [
        {
            icon: <FaBrain />,
            text: "Advanced AI Solutions"
        },
        {
            icon: <FaCloud />,
            text: "Cloud Integration"
        },
        {
            icon: <FaCode />,
            text: "Custom Software Development"
        },
        {
            icon: <FaHeadset />,
            text: "24/7 Technical Support"
        },
        {
            icon: <FaRocket />,
            text: "Scalable IT Infrastructure"
        }
    ],
};

const positions = [
    {
        id: 1,
        image: images.position1,
        title: 'AI Software Developer',
        content: 'Join our team to design and develop cutting-edge AI software solutions, enhancing automation and efficiency.',
        details: {
            location: 'Remote',
            timing: 'Full Time',
            hours: 'Flexible Working Hours',
            experience: 'Minimum 3 Years in AI Development',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$100K - $140K',
            deadline: 'Apply Now - Open Until Filled',
            number: '123-456-7890',
        },
        overviews: [
            'Join our team as an AI Software Developer! You will be responsible for designing and developing cutting-edge AI software solutions, enhancing automation and efficiency for diverse industries. This is a fantastic opportunity to work remotely in a forward-thinking environment and advance your career in AI technology.',
        ],
        responsibilities: [
            'Design and develop AI algorithms and models.',
            'Collaborate with cross-functional teams to implement AI solutions.',
            'Analyze data and optimize machine learning models.',
            'Stay up-to-date with the latest AI advancements.',
            'Ensure scalability and performance of AI systems.',
        ],
        qualifications: [
            'Proven experience in AI development and machine learning.',
            'Strong programming skills in Python, TensorFlow, or similar.',
            'Excellent problem-solving and analytical skills.',
            'Ability to work independently and remotely.',
            'Familiarity with cloud platforms and AI frameworks.',
        ],
    },
    {
        id: 2,
        image: images.position2,
        title: 'Cloud Solutions Engineer',
        content: 'Help build scalable cloud platforms that power AI-driven applications for businesses worldwide.',
        details: {
            location: 'New York, USA',
            timing: 'Full Time',
            hours: 'Flexible Working Hours',
            experience: 'Minimum 3 Years in Cloud Engineering',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$120K - $160K',
            deadline: 'Apply Now - Open Until Filled',
            number: '123-456-7890',
        },
        overviews: [
            'Join our team as a Cloud Solutions Engineer! Help build scalable cloud platforms that power AI-driven applications for businesses worldwide. This is a fantastic opportunity to work in a dynamic environment and advance your career in cloud technology.',
        ],
        responsibilities: [
            'Design and implement scalable cloud infrastructure.',
            'Collaborate with AI teams to support machine learning models.',
            'Ensure security and compliance of cloud systems.',
            'Optimize cloud performance and cost efficiency.',
            'Monitor and troubleshoot cloud services.',
        ],
        qualifications: [
            'Proven experience in cloud engineering and architecture.',
            'Strong knowledge of AWS, Azure, or Google Cloud.',
            'Excellent problem-solving and analytical skills.',
            'Ability to work independently and collaboratively.',
            'Familiarity with containerization and Kubernetes.',
        ],
    },
    {
        id: 3,
        image: images.position3,
        title: 'Data Scientist',
        content: 'Analyze complex datasets to provide actionable insights and support AI model development.',
        details: {
            location: 'Remote',
            timing: 'Full Time',
            hours: 'Flexible Working Hours',
            experience: 'Minimum 3 Years in Data Science',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$110K - $150K',
            deadline: 'Apply Now - Open Until Filled',
            number: '123-456-7890',
        },
        overviews: [
            'Join our team as a Data Scientist! Analyze complex datasets to provide actionable insights and support AI model development. This is a fantastic opportunity to work remotely in a data-driven environment and advance your career in data science.',
        ],
        responsibilities: [
            'Analyze large datasets to extract meaningful insights.',
            'Develop machine learning models and algorithms.',
            'Collaborate with cross-functional teams to support AI development.',
            'Optimize data pipelines and workflows.',
            'Communicate findings through data visualization and reports.',
        ],
        qualifications: [
            'Proven experience in data science and analytics.',
            'Strong programming skills in Python, R, or similar.',
            'Excellent statistical and analytical skills.',
            'Ability to work independently and remotely.',
            'Familiarity with data visualization tools and cloud platforms.',
        ],
    },
    {
        id: 4,
        image: images.position4,
        title: 'UX/UI Designer',
        content: 'Create intuitive and visually appealing interfaces for AI applications to enhance user engagement.',
        details: {
            location: 'San Francisco, USA',
            timing: 'Full Time',
            hours: 'Flexible Working Hours',
            experience: 'Minimum 3 Years in UX/UI Design',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$90K - $120K',
            deadline: 'Apply Now - Open Until Filled',
            number: '123-456-7890',
        },
        overviews: [
            'Join our team as a UX/UI Designer! Create intuitive and visually appealing interfaces for AI applications to enhance user engagement. This is a fantastic opportunity to work in a creative environment and advance your career in UX/UI design.',
        ],
        responsibilities: [
            'Design user-friendly and visually stunning interfaces.',
            'Collaborate with product and development teams.',
            'Conduct user research and gather feedback.',
            'Create wireframes, prototypes, and design mockups.',
            'Ensure a seamless user experience across platforms.',
        ],
        qualifications: [
            'Proven experience in UX/UI design.',
            'Proficiency in design tools like Figma, Sketch, or Adobe XD.',
            'Strong understanding of user-centered design principles.',
            'Ability to work independently and collaboratively.',
            'Familiarity with front-end technologies is a plus.',
        ],
    },
    {
        id: 5,
        image: images.position5,
        title: 'AI Project Manager',
        content: 'Lead cross-functional teams to deliver innovative AI solutions on time and within budget.',
        details: {
            location: 'Remote',
            timing: 'Full Time',
            hours: 'Flexible Working Hours',
            experience: 'Minimum 5 Years in Project Management',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$120K - $150K',
            deadline: 'Apply Now - Open Until Filled',
            number: '123-456-7890',
        },
        overviews: [
            'Join our team as an AI Project Manager! Lead cross-functional teams to deliver innovative AI solutions on time and within budget. This is a fantastic opportunity to work remotely and drive success in the AI industry.',
        ],
        responsibilities: [
            'Plan and manage AI projects from conception to delivery.',
            'Coordinate with engineering, data science, and design teams.',
            'Ensure project timelines and budgets are met.',
            'Identify and mitigate project risks.',
            'Communicate project progress to stakeholders.',
        ],
        qualifications: [
            'Proven experience in project management, preferably in AI.',
            'Strong leadership and communication skills.',
            'Familiarity with Agile methodologies.',
            'Ability to work independently and remotely.',
            'Proficiency in project management tools like Jira or Trello.',
        ],
    },
    {
        id: 6,
        image: images.position6,
        title: 'AI Security Analyst',
        content: 'Safeguard our AI systems by analyzing threats, mitigating risks, and ensuring secure deployment environments.',
        details: {
            location: 'Remote',
            timing: 'Full Time',
            hours: 'Flexible Working Hours',
            experience: 'Minimum 3 Years in Cybersecurity',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$115K - $145K',
            deadline: 'Apply Now - Open Until Filled',
            number: '123-456-7890',
        },
        overviews: [
            'Join our team as an AI Security Analyst! Safeguard our AI systems by analyzing threats, mitigating risks, and ensuring secure deployment environments. This is a fantastic opportunity to work remotely and protect cutting-edge AI technologies.',
        ],
        responsibilities: [
            'Analyze and assess security risks in AI systems.',
            'Develop and implement security protocols and policies.',
            'Monitor systems for suspicious activity and respond to incidents.',
            'Collaborate with development teams to enhance security measures.',
            'Conduct regular security audits and compliance checks.',
        ],
        qualifications: [
            'Proven experience in cybersecurity, preferably in AI environments.',
            'Strong knowledge of threat analysis and risk mitigation.',
            'Familiarity with security tools and frameworks.',
            'Ability to work independently and remotely.',
            'Excellent problem-solving and analytical skills.',
        ],
    }
];

const benefits = [
    {
        id: 1,
        title: "Global Impact",
        description: "Be a part of creating technology solutions that leave a lasting, positive impact on businesses and communities across the globe.",
        icon: <FaGlobe /> // Globe Icon
    },
    {
        id: 2,
        title: "Flexibility at Work",
        description: "Experience the freedom of flexible schedules and remote work options while contributing to impactful projects.",
        icon: <FaClock /> // Clock Icon
    },
    {
        id: 3,
        title: "Collaborative Culture",
        description: "Work alongside passionate and talented individuals in an environment that fosters creativity, innovation, and teamwork.",
        icon: <FaNetworkWired /> // Network Icon
    },
    {
        id: 4,
        title: "Innovative Solutions",
        description: "Join us in developing transformative AI and IT solutions that are revolutionizing industries and creating new opportunities worldwide.",
        icon: <FaRocket /> // Rocket Icon
    },
    {
        id: 5,
        title: "Skill Enhancement",
        description: "Participate in exclusive training programs and workshops to advance your technical expertise and stay ahead in the fast-evolving tech landscape.",
        icon: <FaBrain /> // Brain Icon
    },
    {
        id: 6,
        title: "Competitive Rewards",
        description: "We provide attractive compensation packages, including performance incentives and benefits, to value your contributions to our mission.",
        icon: <FaGem /> // Gem Icon
    },
];

export { positions, benefits, careerIntro };